export function getDocFileNameFromPath(path, removeTimestampPrefix = false) {
    const filename = path && path.match(/.+\/([^\/]+)$/)[1];
    if (removeTimestampPrefix && filename) {
        return filename.substring(filename.indexOf('-') + 1);
    }
    else
        return filename;
}